<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card">

        
        <h4>List of Reminder Types</h4>
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <Button
            label="New Reminder Type"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          />
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="filters"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>
  
        <RerminderTypesTable
          :key="reminderTypesKey"
          :reminderTypes="reminderTypes"
          :loading="loading"
          @edit-reminder-type="editReminderType"
        />

        <ReminderTypeForm
          :reminderTypeToEdit="reminderType"
          :key="reminderTypeFormKey"
          :reminderTypeForm="reminderTypeForm"
          :disabledArr="disabledArr"
          @close="hideRerminderTypeDialog"
          @save="saveReminderType"
        />

      </div>
    </div>
  </div>
</template>

<script>
import ActivityService from "@/service/ActivityService";

import RerminderTypesTable from './reminderTypesTable'
import ReminderTypeForm from './reminderTypeForm'

export default {
  components: {
    RerminderTypesTable,
    ReminderTypeForm
  },
  data: () => ({
    activityService: new ActivityService(),
    filters: '',
    reminderTypesKey1: 0,
    reminderTypes: [],
    reminderTypeForm: false,
    reminderTypeFormKey1: 0,
    disabledArr: [],
    reminderType: {},
    requesting: false
  }),
  computed: {
    reminderTypesKey: {
      set(val) {
        this.reminderTypesKey1++
      },
      get() {
        return 'ReminderTypesTable' + this.reminderTypesKey1.toString()
      }
    },
    reminderTypeFormKey: {
      set(val) {
        this.reminderTypeFormKey1++
      },
      get() {
        return 'ReminderTypeForm' + this.reminderTypeFormKey1.toString()
      }
    },
    loading() {
      if (this.reminderTypes && this.reminderTypes[0]) {
        return false
      } else {
        if (this.requesting) {
          return true
        } else {
          return false
        }
      }
    }
  },
  created() {
    this.getAllReminderTypes()
    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
  },
  watch: {
    filters(val) {
      this.reminderTypesKey++
    },
    reminderTypeForm(val) {
      this.reminderTypeFormKey++
    },
    reminderTypes(val) {
      if (val && Array.isArray(val)) {
        this.reminderTypesKey++
      }
    }
  },
  methods: {
    editReminderType(reminderType) {
      this.reminderType = reminderType
      this.reminderTypeForm = true
    },
    saveReminderType(reminderType) {
      
      delete reminderType.colourCode

      if (reminderType.id) {

        this.activityService
          .editReminderType(reminderType)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "Rerminder type updated",
              detail: "Rerminder type updated successfully.",
              life: 5000,
            });
          
            this.reminderTypeForm = false
            this.getAllReminderTypes()
            this.getAllActiveReminderTypesByHard()
          })
          .catch(err => {
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while editing reminder type",
              life: 5000,
            })
          })
      } else {
        this.activityService
          .saveReminderType(reminderType)
          .then(data => {
            this.$toast.add({
              severity: "success",
              summary: "Rerminder type saved",
              detail: "Rerminder type saved successfully.",
              life: 5000,
            });
          
            this.reminderTypeForm = false
            this.getAllReminderTypes()
            this.getAllActiveReminderTypesByHard()
          })
          .catch(err => {
            
                  
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving reminder type",
              life: 5000,
            })
          })
      }
    },
    hideRerminderTypeDialog() {
      this.reminderType = {}
      this.reminderTypeForm = false
    },
    getAllReminderTypes() {
      this.requesting = true
      this.activityService
        .getAllReminderTypes()
        .then(data => {
          this.requesting = false
          this.reminderTypes = data
        })
        .catch(err => {
          this.requesting = false
          
          
                
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting reminder types",
          //   life: 5000,
          // })
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "reminderTypes"'
          })
        })
    },
    getAllActiveReminderTypesByHard() {
      this.activityService
        .getAllActiveReminderTypesByHard()
        .then(data => {})
        .catch(err => {
          
                
          this.$store.dispatch('addErrorMessage', {
            severity: 'error',
            content: 'Some data was not loaded from "activeReminderTypes"'
          })
        })
    },
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    },
    openNew() {
      this.reminderType = {}
      this.reminderTypeForm = true
    }
  }
}
</script>

<style>

</style>